export * from './baCard.component';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baCard/index.ts